/**
 * 전화번호 8자리 넘패드 (010 고정)
 * docs/tools_all.md §11-1
 *
 * 본 PR(올인원) 한정 사용. PhoneNumpad 의 3개 레거시 페이지(JrMember/Alimtalk/QrSticker)
 * 마이그레이션은 별도 PR (R3 — 풀 롤아웃 + 1주 모니터링).
 */

import React from 'react';
import './PhoneNumpad.css';

const NUMPAD_KEYS = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['clear', '0', 'backspace'],
];

export default function PhoneNumpad({
  digits,
  onChange,
  onSubmit,
  disabled = false,
  errorText = null,
  helpText = '뒤 8자리 입력',
  submitLabel = '📱 조회',
  testIdPrefix = 'phone-numpad',
}) {
  const handleKey = (key) => {
    if (disabled) return;
    // Both consumers pass a React state setter. Queue every tap against the
    // latest value, including multiple taps before the next render.
    onChange(previous => {
      if (key === 'clear') return '';
      if (key === 'backspace') return previous.slice(0, -1);
      return previous.length >= 8 ? previous : previous + key;
    });
  };

  const submitDisabled = disabled || digits.length !== 8;

  return (
    <div className="phone-numpad" data-testid={testIdPrefix}>
      <div className="phone-display" data-testid={`${testIdPrefix}-display`}>
        <span className="phone-prefix">010</span>
        <span className="phone-digits">
          {digits.padEnd(8, '·').split('').map((c, i) => (
            <span key={i} className={c === '·' ? 'placeholder' : 'filled'}>{c}</span>
          ))}
        </span>
      </div>
      {helpText && <div className="phone-help">{helpText}</div>}
      {errorText && <div className="phone-error" data-testid={`${testIdPrefix}-error`}>{errorText}</div>}

      <div className="numpad-grid">
        {NUMPAD_KEYS.flat().map((key) => (
          <button
            key={key}
            type="button"
            className={`numpad-key numpad-${key}`}
            onClick={() => handleKey(key)}
            disabled={disabled}
            data-testid={`${testIdPrefix}-key-${key}`}
          >
            {key === 'backspace' ? '⌫' : key === 'clear' ? 'C' : key}
          </button>
        ))}
      </div>

      <button
        type="button"
        className="phone-submit"
        onClick={onSubmit}
        disabled={submitDisabled}
        data-testid={`${testIdPrefix}-submit`}
      >
        {submitLabel}
      </button>
    </div>
  );
}
